module.exports = __webpack_public_path__ + "img/al.82aaa29a.png";